import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  SkeletonGroup,
  SkeletonBone,
  SkeletonCard,
  SkeletonSection,
  SkeletonCircle,
} from '@/components/common/skeleton';

export const PaymentsScreenSkeleton: React.FC = () => (
  <SkeletonGroup style={styles.container}>
    {/* Payment card skeleton */}
    <SkeletonCard>
      <View style={styles.cardHeader}>
        <SkeletonCircle size={48} />
        <View style={styles.cardHeaderText}>
          <SkeletonBone width={90} height={22} borderRadius={60} />
          <SkeletonBone width={140} height={16} />
          <SkeletonBone width={180} height={14} />
        </View>
      </View>
      <SkeletonBone width={100} height={28} />
      <SkeletonBone width={120} height={36} borderRadius={8} />
    </SkeletonCard>

    {/* Payment methods section */}
    <SkeletonSection headerWidth={140}>
      <SkeletonCard>
        <SkeletonBone width="70%" height={16} />
        <SkeletonBone width="50%" height={14} />
      </SkeletonCard>
    </SkeletonSection>

    {/* Transaction history section */}
    <SkeletonSection headerWidth={160}>
      <SkeletonBone width="100%" height={14} />
      <SkeletonBone width="100%" height={14} />
      <SkeletonBone width="80%" height={14} />
    </SkeletonSection>
  </SkeletonGroup>
);

const styles = StyleSheet.create({
  container: {
    padding: 16,
    gap: 20,
  },
  cardHeader: {
    flexDirection: 'row',
    gap: 14,
  },
  cardHeaderText: {
    flex: 1,
    gap: 6,
  },
});
